import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';

@Component({
  selector: 'my-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.less'],
})
export class ConfirmComponent implements OnInit {
  /**
   * 是否显示 true显示 false隐藏
   */
  @Input() visible: boolean = false;
  /**
   * 弹出框宽度
   */
  @Input() width: number | string = 432;
  /**
   * 提示标题
   */
  @Input() title: string = '确认提示';
  /**
   * 提示内容
   */
  @Input() content: string = '';
  /**
   * 提示内容 模板
   */
  @Input() body: TemplateRef<any>;
  /**
   * 提示状态 success|notice|error/tip
   */
  @Input() status: string = 'success';
  /**
   * 是否显示确认按钮
   */
  @Input() showSure: boolean = true;
  /**
   * 是否显示取消按钮
   */
  @Input() showCancel: boolean = true;
  /**
   * 确认按钮文字
   */
  @Input() sureText: string = '确定';
  /**
   * 取消按钮文字
   */
  @Input() cancelText: string = '取消';
  @Input() conf: object;
  /**
   * 点击确定按钮事件
   */
  @Output() sure = new EventEmitter();
  /**
   * 点击取消按钮事件
   */
  @Output() cancel = new EventEmitter();
  statusIcon: object = {
    success: 'icon_success',
    notice: 'icon_notice',
    error: 'icon_fail',
    tip: 'icon_tip',
  };

  constructor() {}

  ngOnInit(): void {}

  /**
   * 点击取消按钮
   */
  clickCancel(): void {
    this.cancel.emit('11111');
  }

  /**
   * 点击确认按钮
   */
  clickSure(): void {
    this.sure.emit('11111');
    // this.visible=false;
  }
}
